<div class="spatial-container">
  <svg
    #gridSvg
    [attr.width]="width"
    [attr.height]="height"
    class="spatial-grid"
    (mousedown)="onMouseUp()">
    <ng-container *ngFor="let x of gridLines">
      <line
        [attr.x1]="toSvgX(x)"
        [attr.y1]="0"
        [attr.x2]="toSvgX(x)"
        [attr.y2]="height"
        [ngClass]="{
          'spatial-grid-axis': x === 0,
          'spatial-grid-line': x !== 0,
        }" />
    </ng-container>
    <ng-container *ngFor="let y of gridLines">
      <line
        [attr.x1]="0"
        [attr.y1]="toSvgY(y)"
        [attr.x2]="width"
        [attr.y2]="toSvgY(y)"
        [ngClass]="{
          'spatial-grid-axis': y === 0,
          'spatial-grid-line': y !== 0,
        }" />
    </ng-container>
    <ng-container *ngFor="let x of gridLines">
      <text
        [attr.x]="toSvgX(x) + (x === 0 ? 4 : 0)"
        [attr.y]="toSvgY(0) - 4"
        class="spatial-grid-label"
        [textContent]="x" />
    </ng-container>
    <ng-container *ngFor="let y of gridLines">
      <text
        [attr.x]="toSvgX(0) + 4"
        [attr.y]="toSvgY(y) - (y === 0 ? 4 : 0)"
        class="spatial-grid-label"
        [textContent]="y" />
    </ng-container>

    <g *ngFor="let user of users()" class="draggable" (mousedown)="onMouseDown($event, user)">
      <circle
        [attr.cx]="toSvgX(user.coordinates.x)"
        [attr.cy]="toSvgY(user.coordinates.y)"
        r="6"
        class="spatial-item-circle" />
      <text
        [attr.x]="toSvgX(user.coordinates.x) + 8"
        [attr.y]="toSvgY(user.coordinates.y) - 8"
        class="spatial-item-label">
        {{ user.data.name }} ({{ user.id }})
      </text>
    </g>
  </svg>
</div>
